import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

import { Select } from 'antd';
import { ChevronDown } from 'lucide-react';

import { TCategory } from '@components/types';

interface StoreHorizontalControllerProps {
  serviceOptions: { value: string, label: string }[];
  sortingOptions: { value: string, label: string }[];
  handleServiceChange: (service: 'isDelivery' | 'isPickup') => void;
  handleSortingChange: (option: string) => void;
  categoryId: null | number;
  categories: TCategory[];
  handleCategoryChange: (id: number) => void;
}

export default function StoreHorizontalController({
  sortingOptions,
  serviceOptions,
  categories,
  categoryId,
  handleCategoryChange,
  handleSortingChange,
  handleServiceChange
}: StoreHorizontalControllerProps) {
  const [width, setWidth] = useState(0);
  const carouselRef = useRef<HTMLDivElement | null>(null);

  function onSortingChange(value: string) {
    handleSortingChange(value);
  };

  function onServiceFilterChange(value: 'isDelivery' | 'isPickup') {
    handleServiceChange(value)
  };

  useEffect(() => {
    if (carouselRef.current) {
      setWidth(carouselRef.current?.scrollWidth - carouselRef.current.offsetWidth);
    }
  }, [categories]);

  return (
    <motion.div
      ref={carouselRef}
      whileTap={{ cursor: 'grabbing' }}
      className="h-fit p-2 md:hidden relative z-10 overflow-x-hidden cursor-grab">
      <motion.div
        drag="x"
        dragConstraints={{ right: 0, left: -width }}
        className="w-full flex gap-x-2.5"
      >
        <Select
          size='middle'
          placeholder='Sort'
          options={sortingOptions}
          onChange={onSortingChange}
          popupMatchSelectWidth={false}
          suffixIcon={<ChevronDown className='w-2.5 h-2.5 text-neutral-600' />}
        />

        <Select
          size='middle'
          placeholder='Service'
          options={serviceOptions}
          onChange={onServiceFilterChange}
          popupMatchSelectWidth={false}
          suffixIcon={<ChevronDown className='w-2.5 h-2.5 text-neutral-600' />}
        />

        {categories?.map((category) => (
          <button
            type="button"
            key={category.id}
            onClick={() => handleCategoryChange(category.id)}
            className={`px-4 h-8 grid place-items-center rounded border border-solid border-neutral-200 
              ${categoryId === category.id ? 'bg-brand_indigo' : 'bg-neutral-100'}
            `}
          >
            <span
              className={`text-sm 
                ${categoryId === category.id ? 'text-neutral-100' : 'text-neutral-800'} 
                font-manrope font-semibold whitespace-nowrap`
              }
            >
              {category.name}
            </span>
          </button>
        ))}
      </motion.div>
    </motion.div>
  )
}
